<template>
    <ui-modal title="Vehicle Presence" ref="vehiclePresenceModal" size="small" class="presence-modal" :contain-focus="false" dismiss-on="close-button esc">
        <div v-if="booking">
            <ui-select :disabled="isLoading" v-model="presenceProxy" :options="presenceOptions" label="Vehicle Presence"></ui-select>
            <ui-textbox :disabled="isLoading" v-model="booking.vehicle_key_number" label="Key Number" v-if="BookingPresenceStatuses.CUSTOMER !== booking.vehicle_presence_status"></ui-textbox>
            <ui-button :loading="isLoading" @click="save">Save Changes</ui-button>
        </div>
    </ui-modal>
</template>

<script>
    import { BookingPresenceStatusList, BookingResource, BookingPresenceStatuses } from '../../classes/Api/Booking'

    export default {
        data() {
            return {
                booking: null,
                isLoading: false,
                BookingPresenceStatuses,
            }
        },
        methods: {
            open(booking) {
                this.booking = Object.assign({}, booking);
                this.$refs.vehiclePresenceModal.open();
            },
            save() {
                this.isLoading = true

                if (BookingPresenceStatuses.CUSTOMER === this.booking.vehicle_presence_status) {
                    this.booking.vehicle_key_number = null
                }

                BookingResource.update(this.booking.id, this.booking).then(response => {
                    this.isLoading = false
                    this.$refs.vehiclePresenceModal.close()
                    this.$emit('saved', response.data);
                }, (e) => { handleApiError(e); this.isLoading = false })
            }
        },
        computed: {
            presenceOptions() {
                return BookingPresenceStatusList
            },
            presenceProxy: {
                get() {
                    return this.presenceOptions.find(item => { 
                        return item.value === this.booking.vehicle_presence_status 
                    })
                },
                set(value) {
                    this.booking.vehicle_presence_status = value.value
                }
            }
        }
    }
</script>